import React from 'react';
import { Button, Divider, Modal, Row } from 'antd';
import './ScheduleModel.scss';
import { SuccessTick } from 'components/Icons';
import PageHeader from 'components/PageHeader';
import moment from 'moment-timezone';
import { useReactiveVar } from '@apollo/client';
import { userVar } from 'graphql/cache';
import { getUserDateFormatForSchedule } from './ScheduleModel';

export const ScheduleSuccessModel = ({ isOpen, onCancel, scheduleInfo }) => {
  const user = useReactiveVar(userVar);
  // Current date and time in AM/PM format
  const date = moment(scheduleInfo?.time).format(getUserDateFormatForSchedule(user));
  const time = moment(scheduleInfo?.time).format('hh:mm A');

  return isOpen ? (
    <Modal
      className="schedule-success-modal-wrapper"
      maskClosable={false}
      visible
      footer={null}
      centered={true}
      onCancel={onCancel}>
      <Row className="content" align="middle">
        <SuccessTick />
        <PageHeader pageTitle="Proposal scheduled!" />
        <p className="info-text">
          You're all set! Your proposal is on track for delivery on {date} at {time}{' '}
          {scheduleInfo?.tz?.label}.
        </p>
      </Row>
      <Divider />
      <Row className="footer" align="middle">
        <Button className="large-btn secondary-btn" onClick={onCancel}>
          {' '}
          Got It
        </Button>
      </Row>
    </Modal>
  ) : (
    <> </>
  );
};
